"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  HelpIconWrapper: {
    display: 'flex'
  },
  Icon: {
    cursor: 'help',
    flexGrow: 0,
    flexShrink: 0,
    margin: {
      top: 8,
      left: 7
    }
  }
};
exports["default"] = _default;
//# sourceMappingURL=style.js.map